export const CONSENT_STORAGE_KEY = 'leion_cookie_consent';
export const CONSENT_VERSION = '2026-08-23';
export const CONSENT_EVENT = 'leion-cookie-preferences';

const ANALYTICS_STORAGE_KEYS = [
  'leion_visitor_id',
  'leion_analytics_token',
];

const ANALYTICS_SESSION_KEYS = [
  'leion_session_id',
  'leion_session_started_at',
];

export const getConsentRecord = () => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const record = JSON.parse(raw);
    return record?.version === CONSENT_VERSION ? record : null;
  } catch {
    return null;
  }
};

export const hasAnalyticsConsent = () => getConsentRecord()?.choice === 'accepted';

export const saveConsentChoice = (choice) => {
  if (typeof window === 'undefined') return;

  const record = {
    choice,
    version: CONSENT_VERSION,
    timestamp: new Date().toISOString(),
  };

  window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(record));
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: record }));
};

export const openCookiePreferences = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: { open: true } }));
};

export const clearAnalyticsStorage = () => {
  if (typeof window === 'undefined') return;

  ANALYTICS_STORAGE_KEYS.forEach((key) => window.localStorage.removeItem(key));
  ANALYTICS_SESSION_KEYS.forEach((key) => window.sessionStorage.removeItem(key));

  ['_ga', '_gid', '_gat', '_gcl_au'].forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    document.cookie = `${name}=; Max-Age=0; path=/; domain=.${window.location.hostname}; SameSite=Lax`;
  });
};
